var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 222,
    viewBox: "0 0 201 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3159_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.248 38.1135C124.05 38.1186 144.206 45.3429 160.282 58.5554C176.358 71.7678 187.36 90.1507 191.412 110.572C195.464 130.993 192.315 152.188 182.503 170.546C172.691 188.904 156.823 203.289 137.602 211.249C118.381 219.21 96.9963 220.253 77.0927 214.202C57.1892 208.15 39.998 195.378 28.4486 178.062C16.8991 160.746 11.7061 139.958 13.7545 119.239C15.8028 98.5205 24.9657 79.1538 39.6818 64.4391C48.013 56.053 57.9243 49.4051 68.8412 44.8807C79.7582 40.3563 91.4637 38.0455 103.279 38.082L103.248 38.1135ZM103.279 34.1528C84.7224 34.1466 66.5803 39.6482 51.1472 49.9617C35.7141 60.2753 23.6833 74.9377 16.576 92.0947C9.46881 109.252 7.60443 128.133 11.2186 146.351C14.8329 164.568 23.7633 181.304 36.8808 194.442C49.9982 207.579 66.7134 216.529 84.9127 220.158C103.112 223.788 121.978 221.934 139.125 214.832C156.272 207.731 170.929 195.699 181.244 180.259C191.559 164.82 197.068 146.665 197.074 128.092C197.074 103.186 187.189 79.3004 169.593 61.6893C151.997 44.0781 128.132 34.1843 103.248 34.1843L103.279 34.1528Z",
    fill: "#056687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.676 146.559C154.676 145.687 160.297 144.988 167.238 144.988",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.904 57.3798C104.939 57.1286 106.005 57 107.08 57C109.485 57 111.846 57.6437 113.918 58.8645C115.991 60.0853 117.699 61.8388 118.867 63.9435L118.871 63.9511L118.876 63.9586L144.597 109.387L144.597 109.388L170.303 154.825C175.598 164.185 168.935 175.769 158.508 175.769H157.222C159.054 174.362 160.598 172.604 161.76 170.589C163.307 167.906 164.122 164.863 164.121 161.765C164.12 158.667 163.305 155.625 161.757 152.942L161.756 152.942L136.051 108.385L136.05 108.385L110.329 63.8198C108.787 61.1478 106.571 58.9274 103.904 57.3798ZM98.386 55.3167C101.031 53.7993 104.028 53 107.08 53C110.199 53 113.261 53.8349 115.948 55.418C118.633 56.9995 120.847 59.2703 122.361 61.9951L122.365 62.0028L148.078 107.417L148.079 107.418L173.785 152.855L173.785 152.855C180.519 164.76 172.138 179.769 158.508 179.769H55.6523V179.415H43.6327C40.5368 179.415 37.4955 178.599 34.8147 177.05C32.1338 175.5 29.908 173.272 28.3607 170.589C26.8135 167.906 25.9993 164.863 26 161.765C26.0007 158.667 26.816 155.625 28.3642 152.942L28.3645 152.942L54.0703 108.385L54.0705 108.385L79.7922 63.8198L81.4503 64.7768L79.7922 63.8198C81.3399 61.1384 83.5655 58.9116 86.2455 57.3634C88.9256 55.8151 91.9657 55 95.0605 55C96.181 55 97.2943 55.1069 98.386 55.3167ZM88.2464 60.827C90.3183 59.63 92.6684 59 95.0605 59C97.4525 59 99.8026 59.63 101.875 60.827C103.946 62.0239 105.667 63.7456 106.864 65.8193L132.586 110.384L132.586 110.384L158.292 154.941L158.292 154.942C159.49 157.016 160.12 159.37 160.121 161.766C160.121 164.162 159.492 166.516 158.295 168.591C157.098 170.666 155.377 172.389 153.305 173.587C151.232 174.784 148.881 175.415 146.488 175.415H43.6327C41.2397 175.415 38.8887 174.784 36.8162 173.587C34.7436 172.389 33.0224 170.666 31.8258 168.591C30.6293 166.516 29.9995 164.162 30 161.766C30.0005 159.37 30.6313 157.016 31.8288 154.942L31.829 154.941L57.5348 110.384L57.535 110.384L83.2565 65.8193C84.4535 63.7456 86.1744 62.0239 88.2464 60.827Z",
    fill: "#FBB500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.559 82.9066C118.559 82.0344 124.471 81.335 131.781 81.335",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.04 86.8358C121.04 85.9636 126.952 85.2642 134.262 85.2642",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.395 134.772C148.395 133.9 154.016 133.2 160.957 133.2",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2188 144.988C89.5078 144.988 87.1523 141.098 87.1523 136.343L85.582 99.4089C85.582 97.1163 86.492 94.9176 88.1117 93.2965C89.7314 91.6754 91.9281 90.7646 94.2188 90.7646C96.5093 90.7646 98.7061 91.6754 100.326 93.2965C101.946 94.9176 102.855 97.1163 102.855 99.4089L100.5 136.343C100.5 141.098 98.9689 144.988 94.2188 144.988Z",
    fill: "#FBB500",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4336 167.777C96.9026 167.777 99.7148 164.962 99.7148 161.49C99.7148 158.018 96.9026 155.204 93.4336 155.204C89.9646 155.204 87.1523 158.018 87.1523 161.49C87.1523 164.962 89.9646 167.777 93.4336 167.777Z",
    fill: "#FBB500",
    stroke: "#FBB500",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25 20.0391L64.3828 34.1842",
    stroke: "#FBB500",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5742 1.96484V27.8976",
    stroke: "#FBB500",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.395 15.3242L131.514 32.2198",
    stroke: "#FBB500",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8809 32.2197C19.049 32.2197 20.8066 30.4606 20.8066 28.2905C20.8066 26.1205 19.049 24.3613 16.8809 24.3613C14.7127 24.3613 12.9551 26.1205 12.9551 28.2905C12.9551 30.4606 14.7127 32.2197 16.8809 32.2197Z",
    stroke: "#FBB500",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.074 36.1489C198.158 36.1489 199.037 35.2694 199.037 34.1843C199.037 33.0993 198.158 32.2197 197.074 32.2197C195.99 32.2197 195.111 33.0993 195.111 34.1843C195.111 35.2694 195.99 36.1489 197.074 36.1489Z",
    stroke: "#FBB500",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.074 76.2266C198.158 76.2266 199.037 75.347 199.037 74.262C199.037 73.1769 198.158 72.2974 197.074 72.2974C195.99 72.2974 195.111 73.1769 195.111 74.262C195.111 75.347 195.99 76.2266 197.074 76.2266Z",
    stroke: "#FBB500",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31836 72.2976C5.61925 72.2976 6.67383 71.2421 6.67383 69.94C6.67383 68.638 5.61925 67.5825 4.31836 67.5825C3.01747 67.5825 1.96289 68.638 1.96289 69.94C1.96289 71.2421 3.01747 72.2976 4.31836 72.2976Z",
    stroke: "#FBB500",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.66 51.8656C178.178 51.8656 179.408 50.6342 179.408 49.1152C179.408 47.5962 178.178 46.3647 176.66 46.3647C175.142 46.3647 173.912 47.5962 173.912 49.1152C173.912 50.6342 175.142 51.8656 176.66 51.8656Z",
    stroke: "#FBB500",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.584 55.4023C34.1017 55.4023 35.332 54.1708 35.332 52.6518C35.332 51.1328 34.1017 49.9014 32.584 49.9014C31.0663 49.9014 29.8359 51.1328 29.8359 52.6518C29.8359 54.1708 31.0663 55.4023 32.584 55.4023Z",
    fill: "#FBB500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 55C103.8 55 101.667 56.6667 101 57.5C103 58.8333 107.3 61.8 108.5 63C109.7 64.2 114.333 72.8333 116.5 77L125.5 93L150 136L160 153.5C160.833 156 162.5 162.1 162.5 166.5C162.5 170.9 158.833 175 157 176.5C160.167 177 166.5 175.8 170.5 171C174.5 166.2 173.167 158.667 171.5 155L137 93C131.5 82.8333 120.3 62.3 119.5 61.5C118.7 60.7 115.833 58.5 114.5 57.5C113.333 56.6667 110.2 55 107 55Z",
    fill: "#FBB500",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3159_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 222,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.f1d866872ff53e5140f25c630ca79ca3.svg";
export { ForwardRef as ReactComponent };